module.exports = __webpack_public_path__ + "static/img/img-1.4b7049a8.jpg";